import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-orange-500/10 bg-[#0a0500] pt-16 pb-8 px-6 relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-12 text-center md:text-left">
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex items-center gap-3 group transition-all duration-300 hover:opacity-80 mb-4">
              <img 
                src="https://whatastory.b-cdn.net/tools/momentoftruth/logo.svg" 
                alt="Moment of Truth Logo" 
                className="h-8 w-auto drop-shadow-[0_0_15px_rgba(234,88,12,0.3)] group-hover:drop-shadow-[0_0_25px_rgba(234,88,12,0.6)] transition-all duration-300"
              />
              <span className="text-xl font-extrabold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-amber-100 via-orange-300 to-orange-500">
                Moment of Truth
              </span>
            </Link>
            <p className="text-zinc-500 text-sm max-w-xs leading-relaxed">
              The enterprise standard for curating, managing, and embedding premium social proof.
            </p>
          </div>

          <div className="flex gap-12 text-sm font-medium">
            <div className="flex flex-col gap-3">
              <span className="text-amber-50 uppercase tracking-widest text-xs font-bold mb-1">Legal</span>
              <Link to="/privacy" className="text-zinc-400 hover:text-amber-100 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-zinc-400 hover:text-amber-100 transition-colors">Terms of Service</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-amber-50 uppercase tracking-widest text-xs font-bold mb-1">Support</span>
              <a href="mailto:help@momentoftruth.io" className="text-zinc-400 hover:text-amber-100 transition-colors">Contact Us</a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-zinc-600 font-medium tracking-wide">
          <p>© {new Date().getFullYear()} Moment of Truth. All rights reserved.</p>
          <p>Designed for premium SaaS.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;